var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("button", {
    staticClass: "btn-status",
    class: _vm.statusOn ? "btn-status-on" : "btn-status-off",
    attrs: { type: "button" },
    on: {
      click: function ($event) {
        return _vm.$parent.$emit("toggle-status", _vm.model)
      },
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }